export class DatacapResponse {
	CmdResponse: CmdResponse;
	PrintData: { [key: string]: string };
	PrintDataStringArray: string[];
	TranResponse: DatacapTranResponse;
	checkKey: string;

	public constructor(init?: Partial<DatacapResponse>) {
		Object.assign(this, init);
	}
}

export class DatacapTranResponse {
	AID: string;
	AcctNo: string;
	AcqRefData: string;
	Amount: Amount;
	ApplicationLabel: string;
	AuthCode: string;
	CVM: string;
	CaptureStatus: string;
	CardHolderID: string;
	CardType: string;
	Date: string;
	EntryMethod: string;
	IAD: string;
	InvoiceNo: string;
	MerchantID: string;
	OperatorID: string;
	PayAPI_Id: string;
	ProcessData: string;
	RecordNo: string;
	RefNo: string;
	TSI: string;
	TVR: string;
	Time: string;
	TranCode: string;

	public constructor(init?: Partial<DatacapAuthResponseDto>) {
		Object.assign(this, init);
	}
}

export class CmdResponse {
	CmdStatus: string;
	DSIXReturnCode: string;
	ResponseOrigin: string;
	SequenceNo: string;
	TextResponse: string;
	UserTrace: string;
}

export class DatacapAuthResponseDto {
	Account: string;
	Amount: number;
	Authorized: number;
	Brand: string;
	Expiration: string;
	InvoiceNo: string;
	Message: string;
	RefNo: string;
	ResponseOrigin: string;
	Status: string;
	Tip: number;
	Token: string;
	ReturnCode: number;
	AuthCode: string;
	SurchargeWithLookup: string;
	AVSResult: string;
	CardUsage: string;
	CVVResult: string;
	RecurringData: string;
	Trace: string;

	public constructor(init?: Partial<DatacapAuthResponseDto>) {
		Object.assign(this, init);
	}
}

export enum DatacapPaymentStatus {
	DECLINED = 'Declined',
	APPROVED = 'Approved',
	ERROR = 'Error',
	SUCCESS = 'Success',
}

export class Amount {
	Authorize: string;
	Gratuity: string;
	Purchase: string;
}

// Generated by https://quicktype.io

export class DCDirectResponse {
	RStream: DCDirectRStream;

	public constructor(init?: Partial<DCDirectResponse>) {
		Object.assign(this, init);
	}
}

export class DCDirectRStream {
	AID: string;
	AcctNo: string;
	AcqRefData: string;
	ApplicationLabel: string;
	AuthCode: string;
	Authorize: string;
	CVM: string;
	CardHolderID: string;
	CardholderName: string;
	CardType: string;
	CmdStatus: string;
	DSIXReturnCode: string;
	Date: string;
	EntryMethod: string;
	ExpDateMonth: string;
	ExpDateYear: string;
	Gratuity: string;
	InvoiceNo: string;
	Line1: string;
	Line10: string;
	Line11: string;
	Line12: string;
	Line13: string;
	Line14: string;
	Line15: string;
	Line16: string;
	Line17: string;
	Line18: string;
	Line19: string;
	Line2: string;
	Line20: string;
	Line21: string;
	Line22: string;
	Line23: string;
	Line24: string;
	Line25: string;
	Line26: string;
	Line27: string;
	Line28: string;
	Line29: string;
	Line30: string;
	Line31: string;
	Line32: string;
	Line33: string;
	Line34: string;
	Line35: string;
	Line36: string;
	Line3: string;
	Line4: string;
	Line5: string;
	Line6: string;
	Line7: string;
	Line8: string;
	Line9: string;
	MerchantID: string;
	PayAPI_Id: string;
	Purchase: string;
	RecordNo: string;
	RefNo: string;
	ResponseOrigin: string;
	SequenceNo: string;
	TVR: string;
	TextResponse: string;
	Time: string;
	TranCode: string;
	UserTrace: string;
	licenseKey: string;
	dcDirect: boolean;

	public constructor(init?: Partial<DCDirectRStream>) {
		Object.assign(this, init);
	}
}
